import React, { Fragment, FunctionComponent, useEffect } from 'react';
import styles from './TcmOfficeVisit.Styles';
import { Grid } from '@material-ui/core';
import { EmptyDataLabel } from '../../../../../generic-components/empty-data-label/EmptyDataLabel.Component';
import TcmOfficeVisitEntity from '../../../../../../entities/tcm/TcmOfficeVisit.Entity';
import { TooltipTextField } from '../../../../../generic-components/tooltip-textfield/TooltipTextField.Component';
import Moment from 'moment';

interface ITcmOfficeVisitProps {
    referralId: number;
    tcmOfficeVisit?: TcmOfficeVisitEntity;
    handleTcmOfficeVisitEdit: (visit: TcmOfficeVisitEntity) => void;
}

export const TcmOfficeVisit: FunctionComponent<ITcmOfficeVisitProps> = (props: ITcmOfficeVisitProps) => {
    const classes = styles();

    const [officeVisitState, setOfficeVisitState] = React.useState<TcmOfficeVisitEntity>(
        props.tcmOfficeVisit || { referralId: props.referralId }
    );

    useEffect(() => {
        if (props.tcmOfficeVisit) {
            setOfficeVisitState(props.tcmOfficeVisit);
        }
    }, [props.tcmOfficeVisit]);

    const handleTextFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        let newOfficeVisit: TcmOfficeVisitEntity = { ...officeVisitState };
        if (!newOfficeVisit.referralId) {
            newOfficeVisit.referralId = props.referralId;
        }

        newOfficeVisit[event.target.id || event.target.name] = event.target.value;

        setOfficeVisitState(newOfficeVisit);
        props.handleTcmOfficeVisitEdit(newOfficeVisit);
    };

    return (
        <Fragment>
            {officeVisitState ? (
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={6}>
                        <TooltipTextField
                        type="date"
                        id="lastOfficeVisitDate"
                        name="lastOfficeVisitDate"
                        label="Last Office Visit Date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={
                            officeVisitState?.lastOfficeVisitDate
                                ? Moment(officeVisitState?.lastOfficeVisitDate)?.format('YYYY-MM-DD')
                                : ''
                        }
                        onChange={handleTextFieldChange}
                        style={{ width: 200 }}
                    />
                    </Grid>
                    <Grid item xs={6}>
                        <TooltipTextField
                        type="date"
                        id="nextOfficeVisitDate"
                        name="nextOfficeVisitDate"
                        label="Next Office Visit Date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={
                            officeVisitState?.nextOfficeVisitDate
                                ? Moment(officeVisitState?.nextOfficeVisitDate)?.format('YYYY-MM-DD')
                                : ''
                        }
                        onChange={handleTextFieldChange}
                        style={{ width: 200 }}
                    />
                    </Grid>
                </Grid>
            ) : (
                <EmptyDataLabel />
            )}
        </Fragment>
    );
};

